import React, { Component } from 'react';
import Slider from "react-slick";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

class Products extends Component {
	render() {
		var settings = {
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            dots: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.05,
                    dots: false
                    }
                }
            ]
		};
		return (
			<div>
				<section className="product" id="product-1">
					<div className="product__sidebar">
						<div className="product__image">
							<Slider {...settings}>
								<div className="product__image--single">
									<img className="img-fluid left" src="/images/daynightset.png" alt="" />
								</div>
								<div className="product__image--single">
									<img className="img-fluid left" src="/images/product-image-1.png" alt="" />
								</div>
								<div className="product__image--single">
									<img className="img-fluid left" src="/images/product-image-2.png" alt="" />
								</div>
							</Slider>
						</div>
					</div>
					<div className="product__sidebar product__content">
						<div className="d-md-block d-none">
							<div className="pl-md-3 pl-lg-5 pr-md-3 pr-lg-5">
								<h1 className="product__title">Personlised <i>Day and Night Set</i></h1>
								<h4 className="product__subtitle">A simple routine to achieve your healthiest skin.</h4>
								<p className="product__description"><strong>WHAT IS IT?</strong> Your personlised skincare routine that helps repair skin damage from exposure to the elements throughout the day, and stimulates your skin’s natural repair process while you sleep.</p>
								<p className="product__description mb-0"><strong>WHY IS IT UNIQUE?</strong></p>
								<ul className="mb-4">
									<li> <img src="/images/right-tick.svg" alt="" />It’s designed for your skin needs</li>
									<li> <img src="/images/right-tick.svg" alt="" /> Packed with upto 11 Swiss active ingredients</li>
									<li> <img src="/images/right-tick.svg" alt="" /> Hassle-free routine with 4 easy steps.</li>
								</ul>
								<div className="daynightset">
									<div className="row">
										<div className="col-lg-6 pr-3 pl-3 pl-lg-0 pr-lg-2">
											<div className="daynightset__day">
												<div className="row m-0">
													<div className="col-4 m-0">
														<div className="h-100 d-table">
															<h4 className="d-table-cell align-middle text-center"><img src="/images/day-icon.svg" alt="" /> <br />Day Routine</h4>
														</div>
													</div>
													<div className="col-4 pr-1 pl-0">
														<div className="daynightset__product">
															<img className="w-100" src="/images/day-serum-2.png" alt="" />
															<h4>Day Serum</h4>
														</div>
													</div>
													<div className="col-4 pr-0 pl-1">
														<div className="daynightset__product">
															<img className="w-100" src="/images/day-moisturiser-2.png" alt="" />
															<h4>Moisturiser</h4>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-lg-6 pl-3 pr-3 pr-lg-0 pl-lg-2 pt-3 pt-lg-0">
											<div className="daynightset__night">
												<div className="row m-0">
													<div className="col-4 m-0">
														<div className="h-100 d-table">
															<h4 className="d-table-cell align-middle text-center"><img src="/images/night-icon.svg" alt="" /> <br />Night Routine</h4>
														</div>
													</div>
													<div className="col-4 pr-1 pl-0">
														<div className="daynightset__product">
															<img className="w-100" src="/images/day-serum-2.png" alt="" />
															<h4>Night Serum</h4>
														</div>
													</div>
													<div className="col-4 pr-0 pl-1">
														<div className="daynightset__product">
															<img className="w-100" src="/images/night-cream-2.png" alt="" />
															<h4>Night Cream</h4>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="add-to-cart__quantity">
									<button className="btn btn-primary add-to-cart">Add to cart - $79</button> 
									<div className="quantity">
										<input type="number" min="1" max="9" step="1" value="1" />
									</div>
								</div>
								<div className="product-promo-box">
									<div className="ppb-item">
										<img className="ppb--desktop mw-100" src="/images/clean-beauty.svg" />
										<img className="ppb--mobile mw-100" src="/images/clean-beauty11.svg" />
									</div>
									<div className="ppb-item">
										<img className="ppb--desktop mw-100" src="/images/environmentally-friendly.svg" />
										<img className="ppb--mobile mw-100" src="/images/environmentally-friendly11.svg" />
									</div>
									<div className="ppb-item">
										<img className="ppb--desktop mw-100" src="/images/cruelty-free.svg" />
										<img className="ppb--mobile mw-100" src="/images/cruelty-free11.svg" />
									</div>
								</div>
								<div id="product-1-end"></div>
								<div className="top__reviews">
								    <div className="top__reviews__item">
								        <h1 className="top__reviews__item-title">
								            Top Rated Reviews
								            <span>
								                <a href="#">See More</a>
								            </span>
								        </h1>
								        <div className="top__reviews__item-content">
								            <div className="top__reviews__item-content-left">
								                <div className="stars d-inline-block">
								                    <i className="fa fa-2x fa-star"></i>
								                    <i className="fa fa-2x fa-star"></i>
								                    <i className="fa fa-2x fa-star"></i>
								                    <i className="fa fa-2x fa-star"></i>
								                    <i className="fa fa-2x fa-star-o"></i>
								                </div>
								                <div className="review-content">
								                    <span className="review-icon">A</span>
								                    <p>
								                        <span><b>Amanda</b></span><span><i>Verified Buyer</i></span>
								                    </p>
								                </div>
								            </div>
								            <div className="top__reviews__item-content-right">
								                <p><b>My new HOLY GRAIL!</b><br /> My nose feels so smooth! Why wasn’t I exfoliating before, thank you Yours! This glow makes my day!</p>
								            </div>
								        </div>
								    </div>
								</div>
							</div>
						</div>
						<div className="d-md-none d-block">
							<div className="pl-md-3 pl-lg-5 pr-md-3 pr-lg-5">
								<div className="for__mobile p-3">
									<h1 className="product__title">Personlised <i>Day and Night Set</i></h1>
									<h4 className="product__subtitle">A simple routine to achieve your healthiest skin.</h4>
									<p className="product__description"><strong>WHAT IS IT?</strong> Your personlised skincare routine that helps repair skin damage from exposure to the elements throughout the day, and stimulates your skin’s natural repair process while you sleep.</p>
									<div className="add-to-cart__quantity">
										<button className="btn btn-primary add-to-cart">Add to cart - $79</button> 
										<div className="quantity">
											<input type="number" min="1" max="9" step="1" value="1" />
										</div>
										<div className="free__ship mt-3">
											<div className="free__ship-txt text-center">
												<p><img className="mr-1" src="/images/ship-truck.svg" /><strong>Free</strong> Shipping</p>
											</div>
											<div className="free__ship-pack text-right">
												<p>Pack of 30</p>
											</div>
										</div>
									</div>
								</div>
								<div className="padding15">
									<div className="product-promo-box">
										<div className="ppb-item">
											<img className="ppb--desktop mw-100" src="/images/clean-beauty.svg" />
											<img className="ppb--mobile mw-100" src="/images/clean-beauty11.svg" />
										</div>
										<div className="ppb-item">
											<img className="ppb--desktop mw-100" src="/images/cruelty-free.svg" />
											<img className="ppb--mobile mw-100" src="/images/cruelty-free11.svg" />
										</div>
										<div className="ppb-item">
											<img className="ppb--desktop mw-100" src="/images/environmentally-friendly.svg" />
											<img className="ppb--mobile mw-100" src="/images/environmentally-friendly11.svg" />
										</div>
									</div>
									<p className="product__description mb-0"><strong>WHY IS IT UNIQUE?</strong></p>
									<ul className="mb-4">
										<li> <img src="/images/right-tick.svg" alt="" />It’s designed for your skin needs</li>
										<li> <img src="/images/right-tick.svg" alt="" /> Packed with upto 11 Swiss active ingredients</li>
										<li> <img src="/images/right-tick.svg" alt="" /> Hassle-free routine with 4 easy steps.</li>
									</ul>
									<div className="daynightset">
										<div className="row">
											<div className="col-lg-6 pr-3 pl-3 pl-lg-0 pr-lg-2">
												<div className="daynightset__day">
													<div className="row m-0">
														<div className="col-4 m-0">
															<div className="h-100 d-table">
																<h4 className="d-table-cell align-middle text-center"><img src="/images/day-icon.svg" alt="" /> <br />Day Routine</h4>
															</div>
														</div>
														<div className="col-4 pr-1 pl-0">
															<div className="daynightset__product">
																<img className="w-100" src="/images/day-serum-2.png" alt="" />
																<h4>Day Serum</h4>
															</div>
														</div>
														<div className="col-4 pr-0 pl-1">
															<div className="daynightset__product">
																<img className="w-100" src="/images/day-moisturiser-2.png" alt="" />
																<h4>Moisturiser</h4>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="col-lg-6 pl-3 pr-3 pr-lg-0 pl-lg-2 pt-3 pt-lg-0">
												<div className="daynightset__night">
													<div className="row m-0">
														<div className="col-4 m-0">
															<div className="h-100 d-table">
																<h4 className="d-table-cell align-middle text-center"><img src="/images/night-icon.svg" alt="" /> <br />Night Routine</h4>
															</div>
														</div>
														<div className="col-4 pr-1 pl-0">
															<div className="daynightset__product">
																<img className="w-100" src="/images/day-serum-2.png" alt="" />
																<h4>Night Serum</h4>
															</div>
														</div>
														<div className="col-4 pr-0 pl-1">
															<div className="daynightset__product">
																<img className="w-100" src="/images/night-cream-2.png" alt="" />
																<h4>Night Cream</h4>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="top__reviews">
									    <div className="top__reviews__item">
									        <h1 className="top__reviews__item-title">
									            Top Rated Reviews
									            <span>
									                <a href="#">See More</a>
									            </span>
									        </h1>
									        <div className="top__reviews__item-content">
									            <div className="top__reviews__item-content-left">
									                <div className="stars d-inline-block">
									                    <i className="fa fa-2x fa-star"></i>
									                    <i className="fa fa-2x fa-star"></i>
									                    <i className="fa fa-2x fa-star"></i>
									                    <i className="fa fa-2x fa-star"></i>
									                    <i className="fa fa-2x fa-star-o"></i>
									                </div>
									                <div className="review-content">
									                    <span className="review-icon">A</span>
									                    <p>
									                        <span><b>Amanda</b></span><span><i>Verified Buyer</i></span>
									                    </p>
									                </div>
									            </div>
									            <div className="top__reviews__item-content-right">
									                <p><b>My new HOLY GRAIL!</b><br /> My nose feels so smooth! Why wasn’t I exfoliating before, thank you Yours! This glow makes my day!</p>
									            </div>
									        </div>
									    </div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="clearfix"></div>
				</section>
				<section className="product" id="product-2">
					<div className="product__sidebar product__content pl-md-3 pl-lg-5">
						<div className="pr-sm-3 pr-lg-5">
							<div className="padding15 pt-3 pt-md-0">
								<div className="accordion" id="productsecaccordion">
									<Accordion>
								        <AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">Facial Serum | 15 ml</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body">
														<div className="row mb-3 pl-0 pl-md-3">
															<div className="col-lg-5">
																<img src="/images/facial-serum.png" alt="" />
															</div>
															<div className="col-lg-7">
																<h4>Your skin saviour in a bottle</h4>
																<ul>
																	<li><img src="/images/skin-damage.svg" alt="" /> Repairs skin damage</li>
																	<li><img src="/images/skin-imperfaction.svg" alt="" /> Clears skin imperfections</li>
																	<li><img src="/images/skin-tone.svg" alt="" /> Evens out skin tone</li>
																</ul>
															</div>
														</div>
														<p><strong>WHAT IS IT?</strong>A lightweight formula packed with Swiss active ingredients, personalised to target your specific skin concerns: acne, blackheads, pigmentation, wrinkles – you name it!</p>
														<p><strong>WHY IS IT UNIQUE?</strong> It’s highly concentrated with up to 11 Swiss active ingredients that are proven to show results. It’s also tested for the highest standards of safety and efficacy.</p>
													</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
										<AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">Day Moisturiser | 30 ml</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body">
														<div className="row mb-3 pl-0 pl-md-3">
															<div className="col-lg-5">
																<img src="/images/moisturiser.png" alt="" />
															</div>
															<div className="col-lg-7">
																<h4>For balanced hydration all day long</h4>
																<ul>
																	<li><img src="/images/hydration.svg" alt="" /> Intense light-weight hydration</li>
																	<li><img src="/images/pollutants.svg" alt="" /> Protects skin from pollutants</li>
																	<li><img src="/images/texture.svg" alt="" /> Smooths skin texture</li>
																</ul>
															</div>
														</div>
														<p><strong>WHAT IS IT?</strong> Personalised to work for your skin and lifetsyle, it’s filled with the goodness of Swiss active ingredients to hydrate, lock in moisture and shield your skin from damage. A moisturiser you can rely on!</p>
														<p><strong>WHY IS IT UNIQUE?</strong> It absorbs instantly, leaving your skin feeling nourished with no sticky residue – the perfect base for your makeup!</p>
														
													</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
										<AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">Night Cream | 30 ml</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body">
														<div className="row mb-3 pl-0 pl-md-3">
															<div className="col-lg-5">
																<img src="/images/facial-serum.png" alt="" />
															</div>
															<div className="col-lg-7">
																<h4>Put your skin damage to sleep</h4>
																<ul>
																	<li><img src="/images/skin-damage.svg" alt="" /> Repairs daily skin damage</li>
																	<li><img src="/images/detoxifies.svg" alt="" /> Detoxifies your skin</li>
																	<li><img src="/images/regenerate.svg" alt="" /> Regenerates skin cells</li>
																</ul>
															</div>
														</div>
														<p><strong>WHAT IS IT?</strong> Personalised to work for your skin and lifetsyle, it’s filled with the goodness of Swiss active ingredients to hydrate, lock in moisture and shield your skin from damage. A moisturiser you can rely on!</p>
														<p><strong>WHY IS IT UNIQUE?</strong> It absorbs instantly, leaving your skin feeling nourished with no sticky residue – the perfect base for your makeup!</p>
													</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
										<AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">How to Use</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body">
														<h4 className="pl-3 pb-3"><img src="/images/day-icon.svg" alt="" /> Day Routine</h4>
														<p className="text-uppercase">Cleanser <img src="/images/right-arrow.png" /> toner<img src="/images/right-arrow.png" /> Serum<img src="/images/right-arrow.png" /> moisturiser</p>
														<p>1. In the morning, cleanse your face and pat dry. Follow with your toner. </p>
														<p>2. Apply 1-2 pumps of serum to your skin using gentle patting motions. Then apply 1-2 pumps of your moisturiser and gently massage it into your skin using upwards and outwards motions. Don’t forget your neck too! </p>
														<p>3. Follow with your SPF.</p>
														<h4 className="pl-3 pb-3"><img src="/images/night-icon.svg" alt="" /> Night Routine</h4>
														<p className="text-uppercase">Cleanser <img src="/images/right-arrow.png" /> toner<img src="/images/right-arrow.png" /> Serum<img src="/images/right-arrow.png" /> Night Cream</p>
														<p>1. Before Bed, cleanse your face and pat dry. Follow with your toner.</p>
														<p>2. Apply 1-2 pumps of serum to your skin using gentle patting motions. Then apply 1-2 pumps of your night cream and gently massage it into your skin using upwards and outwards motions. Don’t forget your neck too!</p>
														<p> 3. Follow with lots of beauty sleep.</p>
														<div className="row">
															<div className="col-gl-6 col-gl-12">
																<div className="accordion__products ml-3">
																	<div className="row">
																		<div className="col-5">
																			<img src="/images/eye-serum.png" alt="" />
																		</div>
																		<div className="col-7">
																			<div className="accordion__products--text">
																				<h4>Eye Serum</h4>
																				<p>30 ml | $20</p>
																				<button className="btn btn-outline-primary" type="button">Add</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
										<AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">Elevated Ingredients</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body"></div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
									</Accordion>
								</div>
							</div>
						</div>
					</div>
					<div className="product__sidebar">
						<div className="product__image">
							<img className="img-fluid left" src="/images/mask-group.png" alt="" />
						</div>
					</div>
					<div className="clearfix"></div>
				</section>
			</div>
		);
	}
}


export default Products;